export enum ReportType {
  coverage = 'Coverage',
  impact = 'Impact',
  dominant = 'Dominant',
}

export interface ReportTypeOption {
  reportTypeId: number;
  name: string;
  reportType: ReportType;
}
